module.exports = __webpack_public_path__ + "img/al.svg";